import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

import { type PartialDatabaseView } from './types';

/**
 * @see {@link OnViewsStateUpdateCommand}
 */
export type OnViewsStateUpdateCommandProperties = CommandProperties;

export type OnViewsStateUpdateCommandResponse = {
  currentView: PartialDatabaseView;
  views: PartialDatabaseView[];
};

/**
 * Command to handle database view change updates in the native embed experience.
 *
 * This command is triggered when users add, delete or modify a Database view.
 */
export const OnViewsStateUpdateCommand = createCommand<
  OnViewsStateUpdateCommandProperties,
  OnViewsStateUpdateCommandResponse
>('on-views-state-update-command');
